export const embeddedYoutubeUrl = (url) => {
  let videoId, matches;

  if (url.match(/^https?:\/\/[^\/]*youtube\.com\/watch/i)) {
    matches = url.match(/watch\?v=([^&\s\b]+)/i);
    videoId = matches && matches[1];
  }

  if (url.match(/^https?:\/\/youtu\.be/i)) {
    matches = url.match(/youtu\.be\/([^&\s\b]+)/i);
    videoId = matches && matches[1];
  }

  if (videoId) {
    return 'https://www.youtube.com/embed/' + videoId;
  }
};

export const embeddedVimeoUrl = (url) => {
  const vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
  const parsed = url.match(vimeoRegex);

  if (parsed[1]) {
    return 'https://player.vimeo.com/video/' + parsed[1];
  }
};
